import { useToast as useGlobalToast } from "../../composables/useToast.js";

// Same global toast as the legacy app, but every v2 toast defaults to the
// v2 design — the white "card" variant (see global-toast.vue), stacked in
// the bottom-right corner. The legacy app keeps its own look and placement.
export function useToast() {
  const toast = useGlobalToast();
  return (options = {}) => toast({ variant: "card", position: "bottom", alignment: "right", ...options });
}
